import React from "react";

import { Component } from "react";
import TrackedButton from "../../Docuclipper/TrackedButton";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type ToolBtnProps = {
  text: string;
  onClick: (e: any) => void;
  name: string;
  selected: boolean;
};

type ToolBtnState = {};

export default class ToolBtn extends Component<ToolBtnProps, ToolBtnState> {
  public render() {
    const { text, onClick, name, selected } = this.props;
    return (
      <>
        <OverlayTrigger
          popperConfig={{
            modifiers: {
              preventOverflow: {
                enabled: false,
              },
            } as any,
          }}
          placement="top"
          overlay={<Tooltip id="merge-rows"> {text}</Tooltip>}
        >
          <TrackedButton
            action={`tool-${name}`}
            id={`tool-${name}`}
            className={`tool-btn mr-1 ${
              selected ? "tool-btn-selected" : ""
            } ${`btn--tool-${name}`}`}
            onClick={onClick}
            variant={selected ? "primary" : "secondary"}
          >
            {this.props.children}
          </TrackedButton>
        </OverlayTrigger>
      </>
    );
  }
}
